import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'linkify'
})
export class LinkifyPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(text: string): SafeHtml {
    if (!text) return '';

    const urlRegex = /((https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-z]{2,}([\/\w\-.?&=#%]*)?)/gi;
    if (!urlRegex.test(text)) {
      return text;
    }
    const replacedText = text.replace(urlRegex, (url) => {
      const href = url.startsWith('http') ? url : `https://${url}`;
      return `<a class="message-link" href="${href}" target="_blank" rel="noopener noreferrer" role="link" tabindex="0">${url}</a>`;
    });

    return this.sanitizer.bypassSecurityTrustHtml(replacedText);
  }
}
